module.exports = __webpack_public_path__ + "media/images/map-bg@2x-4f49985ab59e0ec2a60c6de7d5bbd4f4.png";